export const SET_USERINFO = 'SET_USERINFO';
export const SET_SYSTEM = 'SET_SYSTEM';
export const SET_PERMS = 'SET_PERMS';
export const SET_ROUTES = 'SET_ROUTES';

